// Shared pipe weight data used by PipeWeight and HangerTools

export const WEIGHT_PIPE_DATA: { label: string; sizes: { nom: string; od: number; id: number; wt: number }[] }[] = [
  {
    label: "Steel Sch 40", sizes: [
      { nom: '1/2"', od: 0.840, id: 0.622, wt: 0.85 },
      { nom: '3/4"', od: 1.050, id: 0.824, wt: 1.13 },
      { nom: '1"', od: 1.315, id: 1.049, wt: 1.68 },
      { nom: '1-1/4"', od: 1.660, id: 1.380, wt: 2.27 },
      { nom: '1-1/2"', od: 1.900, id: 1.610, wt: 2.72 },
      { nom: '2"', od: 2.375, id: 2.067, wt: 3.65 },
      { nom: '2-1/2"', od: 2.875, id: 2.469, wt: 5.79 },
      { nom: '3"', od: 3.500, id: 3.068, wt: 7.58 },
      { nom: '4"', od: 4.500, id: 4.026, wt: 10.79 },
      { nom: '5"', od: 5.563, id: 5.047, wt: 14.62 },
      { nom: '6"', od: 6.625, id: 6.065, wt: 18.97 },
      { nom: '8"', od: 8.625, id: 7.981, wt: 28.55 },
      { nom: '10"', od: 10.750, id: 10.020, wt: 40.48 },
      { nom: '12"', od: 12.750, id: 12.000, wt: 49.56 },
      { nom: '14"', od: 14.000, id: 13.250, wt: 54.57 },
      { nom: '16"', od: 16.000, id: 15.250, wt: 62.58 },
      { nom: '18"', od: 18.000, id: 17.250, wt: 70.59 },
      { nom: '20"', od: 20.000, id: 19.250, wt: 78.60 },
      { nom: '24"', od: 24.000, id: 23.250, wt: 94.62 },
    ],
  },
  {
    label: "Copper Type L", sizes: [
      { nom: '1/2"', od: 0.625, id: 0.545, wt: 0.285 },
      { nom: '3/4"', od: 0.875, id: 0.785, wt: 0.455 },
      { nom: '1"', od: 1.125, id: 1.025, wt: 0.655 },
      { nom: '1-1/4"', od: 1.375, id: 1.265, wt: 0.884 },
      { nom: '1-1/2"', od: 1.625, id: 1.505, wt: 1.14 },
      { nom: '2"', od: 2.125, id: 1.985, wt: 1.75 },
      { nom: '2-1/2"', od: 2.625, id: 2.465, wt: 2.48 },
      { nom: '3"', od: 3.125, id: 2.945, wt: 3.33 },
      { nom: '4"', od: 4.125, id: 3.905, wt: 5.38 },
    ],
  },
  {
    label: "PVC Sch 40", sizes: [
      { nom: '1/2"', od: 0.840, id: 0.622, wt: 0.16 },
      { nom: '3/4"', od: 1.050, id: 0.824, wt: 0.21 },
      { nom: '1"', od: 1.315, id: 1.049, wt: 0.31 },
      { nom: '1-1/4"', od: 1.660, id: 1.380, wt: 0.37 },
      { nom: '1-1/2"', od: 1.900, id: 1.610, wt: 0.42 },
      { nom: '2"', od: 2.375, id: 2.067, wt: 0.56 },
      { nom: '3"', od: 3.500, id: 3.068, wt: 1.07 },
      { nom: '4"', od: 4.500, id: 4.026, wt: 1.46 },
      { nom: '6"', od: 6.625, id: 6.065, wt: 2.79 },
      { nom: '8"', od: 8.625, id: 7.981, wt: 4.24 },
    ],
  },
  {
    label: "Stainless 10S", sizes: [
      { nom: '1/2"', od: 0.840, id: 0.732, wt: 0.43 },
      { nom: '3/4"', od: 1.050, id: 0.884, wt: 0.86 },
      { nom: '1"', od: 1.315, id: 1.097, wt: 1.40 },
      { nom: '1-1/2"', od: 1.900, id: 1.682, wt: 2.09 },
      { nom: '2"', od: 2.375, id: 2.157, wt: 2.64 },
      { nom: '3"', od: 3.500, id: 3.260, wt: 4.33 },
      { nom: '4"', od: 4.500, id: 4.260, wt: 5.61 },
      { nom: '6"', od: 6.625, id: 6.357, wt: 9.29 },
      { nom: '8"', od: 8.625, id: 8.329, wt: 13.40 },
    ],
  },
  {
    label: "Cast Iron SV", sizes: [
      { nom: '2"', od: 2.00, id: 1.96, wt: 3.50 },
      { nom: '3"', od: 3.00, id: 2.96, wt: 4.50 },
      { nom: '4"', od: 4.19, id: 4.00, wt: 4.75 },
      { nom: '6"', od: 6.19, id: 6.00, wt: 7.00 },
      { nom: '8"', od: 8.19, id: 8.00, wt: 9.00 },
      { nom: '10"', od: 10.19, id: 10.00, wt: 11.00 },
      { nom: '12"', od: 12.19, id: 12.00, wt: 13.25 },
    ],
  },
];

export const WATER_DENSITY_LB_PER_CUIN = 0.0361; // lb per cubic inch
